var map = {
	"./de/returnBtn.png": "OtAT",
	"./en/returnBtn.png": "pI5V",
	"./es/returnBtn.png": "xwN6",
	"./fr/returnBtn.png": "EeVG",
	"./ja/returnBtn.png": "tJsL",
	"./ko/returnBtn.png": "d1Wp",
	"./pt/returnBtn.png": "OO8f",
	"./ru/returnBtn.png": "CvND",
	"./tc/returnBtn.png": "hSdP",
	"./th/returnBtn.png": "nobC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+UZA";